module.exports = __webpack_public_path__ + "img/11.51fa6ed1.jpg";